import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

export default function UserIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1772_4784)">
          <path
            d="M26.4368 24.2231L26.8489 24.5982L27.1773 24.148C28.8926 21.7963 29.8333 18.9466 29.8333 16C29.8333 8.37719 23.6228 2.16667 16 2.16667C8.37719 2.16667 2.16667 8.37719 2.16667 16C2.16667 18.947 3.10758 21.7826 4.80825 24.1331L5.13612 24.5863L5.54984 24.2098C8.41911 21.599 12.0996 20.1533 15.9867 20.1533C19.8734 20.1533 23.554 21.5988 26.4368 24.2231ZM0.5 16C0.5 7.44948 7.44948 0.5 16 0.5C24.5505 0.5 31.5 7.44948 31.5 16C31.5 19.8372 30.092 23.5304 27.5231 26.3707C24.5633 29.6275 20.3639 31.5 16 31.5C11.6362 31.5 7.43677 29.6276 4.47705 26.3708C1.90807 23.5305 0.5 19.8372 0.5 16Z"
            fill={theme.palette.main.professional_blue}
            stroke={theme.palette.main.professional_blue}
          />
          <path
            d="M15.9999 17.32C19.0338 17.32 21.4933 14.8606 21.4933 11.8267C21.4933 8.79282 19.0338 6.33337 15.9999 6.33337C12.966 6.33337 10.5066 8.79282 10.5066 11.8267C10.5066 14.8606 12.966 17.32 15.9999 17.32Z"
            fill={theme.palette.main.professional_blue}
            stroke={theme.palette.main.professional_blue}
            strokeWidth="2"
          />
        </g>
        <defs>
          <clipPath id="clip0_1772_4784">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
